import { addDays, startOfMonth, startOfWeek, format } from "date-fns";
import { UserEvent } from "@/api";

export const getWeekHeaders = () => {
  // Get an array of the days of the week starting with Monday
  // Using the app's locale
  // Returns in this format: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
  const weekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
  return Array.from({ length: 7 }, (_, i) =>
    format(addDays(weekStart, i), "EEE").toUpperCase(),
  );
};

export interface CalendarEvent extends UserEvent {
  isClientScheduled?: boolean;
}

// Get dates for a month, month determine from input
export const getCalendarDates = (currentDate: Date) => {
  const firstDayOfMonth = startOfMonth(currentDate);
  const startDate = startOfWeek(firstDayOfMonth, { weekStartsOn: 1 });
  const calendarDates = [];
  for (let i = 0; i < 42; i++) {
    calendarDates.push(addDays(startDate, i));
  }
  return calendarDates;
};
